<template>
  <div class="header">
    <i class="icon-header">
      <chatHeaderIcon />
      <span v-show="this.isShowMessagesCounter">{{ unreadCount }}</span>
    </i>
    {{ translate("chat", "Чат с бустерами и администрацией", {}) }}
  </div>
</template>
<script>
import chatHeaderIcon from "./chatHeaderIcon.vue";

export default {
  props: {
    unreadCount: {
      type: Number,
      default: "0",
    },
  },
  components: {
    chatHeaderIcon,
  },
  computed: {
    isShowMessagesCounter: {
      get: function () {
        return this.unreadCount != 0;
      },
    },
  },
  methods: {
    translate(source, message, params) {
      return translate(source, message, params);
    },
  },
};
</script>
<style lang="scss">
.header {
  position: relative;
  padding-right: 24px;
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 64px;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  color: #5cb85c;
  border-bottom: 1px solid #e1e1e2;
}
.icon-header {
  position: absolute;
  top: 50%;
  margin-top: -12px;
  left: 24px;
  font-weight: bold;
  font-size: 12px;
  color: #ffffff;
  span {
    position: absolute;
    top: -8px;
    right: -7px;
    display: block;
    min-width: 23px;
    height: 21px;
    background: #ff7149;
    border: 2px solid #ffffff;
    border-radius: 10px;
    line-height: 17px;
    text-align: center;
    font-style: normal;
  }
}
</style>
